import axios from "axios";


const GoLogin = () => {
};

export class HttpClient {
    axios;
    isLogin;

    constructor(url, isLogin = true) {
        this.isLogin = isLogin;
        this.axios = axios.create({
            baseURL: url,
            timeout: 5000,
            withCredentials: false,
            headers: {
                Accept: "application/json",
            },
        });

        // 请求拦截器
        this.axios.interceptors.request.use(
            (config) => {
                return config
            },
            (err) => {
                return Promise.reject(err);
            });

        // 返回拦截器
        this.axios.interceptors.response.use(
            (response) => {
                const code = response.data.code; //业务返回代码

                switch (code) {
                    case 200:
                        return Promise.resolve(response);
                    case 401:
                        if (this.isLogin) {
                            GoLogin();
                        }
                        return Promise.reject(response);
                    default:
                        return Promise.reject(response);
                }
            },
            (error) => {
                const status = error.response.status;
                let msg = "请求出错，状态码为：" + status

                if (status === 401) {
                    msg = "登录已失效，请重新登录!"
                    if (this.isLogin) {
                        GoLogin();
                    }
                }
                const response = {
                    data: {
                        code: status,
                        data: error.response.data,
                        msg: msg
                    }
                }
                return Promise.reject(response);
            }
        );
    };

    get(url, params) {

    }

    post(url, params) {
        return new Promise((resolve, reject) => {
            this.axios
                .post(url, params)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    if (!err || !err.data) {
                        err.data = {
                            msg: "请求超时"
                        }
                    }
                    reject(err.data);
                });
        });
    }

    patch(url, params) {
        return new Promise((resolve, reject) => {
            this.axios
                .patch(url, params)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    if (!err || !err.data) {
                        err.data = {
                            msg: "请求超时"
                        }
                    }
                    reject(err.data);
                });
        });
    }

    delete(url, params) {
        return new Promise((resolve, reject) => {
            this.axios
                .delete(url, {data: params})
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    if (!err || !err.data) {
                        err.data = {
                            msg: "请求超时"
                        }
                    }
                    reject(err.data);
                });
        });
    }

    put(url, params) {
        return new Promise((resolve, reject) => {
            this.axios
                .put(url, params)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    if (!err || !err.data) {
                        err.data = {
                            msg: "请求超时"
                        }
                    }
                    reject(err.data);
                });
        });
    }

    request(config) {
        return new Promise((resolve, reject) => {
            this.axios
                .request(config)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    if (!err || !err.data) {
                        err.data = {
                            msg: "请求超时"
                        }
                    }
                    reject(err.data);
                });
        });
    }
}

const APP_URL = process.env.REACT_APP_BASE_URL || "";

const client = new HttpClient(APP_URL, true);

export const baseClient = new HttpClient(APP_URL, false);

export default client;
